import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["output"]
  static values = { url: String, debounce: { type: Number, default: 150 } }

  initialize() { this.timer = null; this.inFlight = null }

  // The first render rides the editor's `lexxy:initialize` action — rendering before
  // Lexxy sets its form value would post a blank body. If it initialized before this
  // controller connected that event is gone, so cover the race here.
  connect() {
    const editor = this.element.querySelector("lexxy-editor")
    if (editor && editor.hasAttribute("connected")) this.render()
  }

  disconnect() { clearTimeout(this.timer); this.inFlight?.abort() }

  refresh() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.render(), this.debounceValue)
  }

  async render() {
    const form = this.element.querySelector("form")
    if (!form || !this.hasOutputTarget) return
    const body = new FormData(form)
    body.delete("_method")
    this.inFlight?.abort()
    this.inFlight = new AbortController()
    let html
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": this.csrfToken(), Accept: "text/html" },
        body,
        signal: this.inFlight.signal,
      })
      if (!response.ok || response.redirected) return
      html = await response.text()
    } catch { return }
    this.outputTarget.innerHTML = html
    this.fitFrame()
  }

  // srcdoc has no intrinsic height, so it is measured once the document is parsed.
  fitFrame() {
    const frame = this.outputTarget.querySelector("iframe")
    if (!frame) return
    const fit = () => {
      const height = frame.contentDocument?.documentElement?.scrollHeight
      if (height) frame.style.height = `${height}px`
    }
    frame.addEventListener("load", fit)
    fit()
  }

  csrfToken() { return document.querySelector('meta[name="csrf-token"]')?.content || "" }
}
